import { render } from "./RegistrationKidsLink.vue?vue&type=template&id=c4a5ce8c"
import script from "./RegistrationKidsLink.vue?vue&type=script&lang=js"
export * from "./RegistrationKidsLink.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__